import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
import { cn } from '../../lib/utils';
interface ButtonProps extends HTMLMotionProps<'button'> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  children: React.ReactNode;
}
export function Button({
  className,
  variant = 'primary',
  size = 'md',
  children,
  ...props
}: ButtonProps) {
  const variants = {
    primary: 'bg-green-600 text-white shadow-[0_0_20px_rgba(22,163,74,0.4)] hover:bg-green-500 hover:shadow-[0_0_30px_rgba(22,163,74,0.6)] border border-green-500',
    secondary: 'bg-zinc-800 text-zinc-100 hover:bg-zinc-700 border border-zinc-700',
    outline: 'bg-transparent border-2 border-green-500 text-green-500 hover:bg-green-500/10'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg font-bold',
    xl: 'px-10 py-5 text-xl font-extrabold'
  };
  return <motion.button whileTap={{
    scale: 0.98
  }} whileHover={{
    scale: 1.02
  }} className={cn('rounded-lg font-medium transition-colors duration-200 flex items-center justify-center gap-2', variants[variant], sizes[size], className)} {...props} data-id="element-214">
      {children}
    </motion.button>;
}